module.exports = [{
      plugin: require('/tmp/3d16f522/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
